import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: '/', name: 'Home',component: Home},
  { path: '/Login', name: 'Login', component: () => import('../views/Login.vue')},
  //{ path: '/Logout', name: 'Logout', component: () => import('../views/Logout.vue')},
  //{ path: '/EventDetails/:id', name: 'EventDetails', component: () => import('../views/EventDetails.vue'), props: true }, // Removed
  //{ path: '/allEvents', name: 'AllEvents', component: () => import(/* webpackChunkName: "about" */ '../views/AllEvents.vue')} // Removed
]

const router = new VueRouter({
  routes
})

export default router
